import { UserType } from '../../../interfaces/userType.enum';
import { ModuleKey, WidgetDef } from './types';
import { accountingWidgets } from './accountingWidgets';
import { inventoryWidgets } from './inventoryWidgets';
import { salesWidgets } from './salesWidgets';

export * from './types';

export const WIDGET_REGISTRY: WidgetDef[] = [
    ...accountingWidgets,
    ...inventoryWidgets,
    ...salesWidgets,
];

export function getWidget(id: string): WidgetDef | undefined {
    return WIDGET_REGISTRY.find(w => w.id === id);
}

/**
 * Whether a widget's role gate admits any of the caller's roles. Boards must apply this to
 * PERSISTED layouts too, not just to the Add-widget picker: a layout saved while the user was an
 * Accountant survives a demotion, and rendering those widgets afterwards means a burst of 403s
 * behind permanent spinners.
 */
export function isWidgetVisibleToRole(widget: WidgetDef, roles: UserType[]): boolean {
    return widget.roles.some(r => roles.includes(r));
}

export function widgetsForRole(roles: UserType[], enabledModules?: ModuleKey[]): WidgetDef[] {
    return WIDGET_REGISTRY.filter(w => {
        const moduleOk = !enabledModules || enabledModules.includes(w.module);
        return isWidgetVisibleToRole(w, roles) && moduleOk;
    });
}
